module.exports = __webpack_public_path__ + "a34cac42f47a7e4862a13ea7d79645d3.png";